export enum FavoriteIposFormField {
  Ticker = 'ticker',
}
